import Axios from "axios";
import { useContext, useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import Select from "react-select";
import { toast } from "react-toastify";
import DashboardContext from "../../../Context";
import TablePriceList from "./TablePriceList";
import InputControl from "../../../components/inputs/InputControl";
import InputDate from "../../../components/inputs/InputDate";
import InputPricing from "../../inputs/InputPricing";
import InputNumber from "../../../components/inputs/InputNumber";

const ModalPriceForm = ({
  showitem,
  handleCloseMoudal,
  refreshPriceTable,
  groupId,
  groupTitle,
  handeldeleteitem,
  handleRefreshGridWorker,
}) => {

  const { sideBardata, authentication, urldashboard } =
    useContext(DashboardContext);

  const [saveLoading, setSaveLoading] = useState(false);

  const [formdata, setFormdata] = useState({});
  const handelsetdataForm = (object) => setFormdata(object);

  const handelValue = (name, value) => {
    switch (name) {
      case 'orderRegistrationType':
        handelsetdataForm({ ...formdata, orderRegistrationType: value })
        break;
      case 'dailyType':
        handelsetdataForm({ ...formdata, dailyType: value })
        break;
      case 'fromDate':
        handelsetdataForm({ ...formdata, fromDate: value })
        break;
      case 'toDate':
        handelsetdataForm({ ...formdata, toDate: value })
        break;
      case 'maleCommission':
        handelsetdataForm({ ...formdata, maleCommission: value })
        break;
      case 'femaleCommission':
        handelsetdataForm({ ...formdata, femaleCommission: value })
        break;
      case 'maleCostPerHour':
        handelsetdataForm({ ...formdata, maleCostPerHour: value })
        break;
      case 'maleBaseAmount':
        handelsetdataForm({ ...formdata, maleBaseAmount: value })
        break;
      case 'femaleBaseAmount':
        handelsetdataForm({ ...formdata, femaleBaseAmount: value })
        break;
      case 'femaleCostPerHour':
        handelsetdataForm({ ...formdata, femaleCostPerHour: value })
        break;
      case 'maleMinimumTime':
        handelsetdataForm({ ...formdata, maleMinimumTime: value })
        break;
      case 'femaleMinimumTime':
        handelsetdataForm({ ...formdata, femaleMinimumTime: value })
        break;
      case 'fromHour':
        handelsetdataForm({ ...formdata, fromHour: value })
        break;
      case 'toHour':
        handelsetdataForm({ ...formdata, toHour: value })
        break;
      default:
        break;
    }
  }

  useEffect(() => {
    handelsetdataForm({ ...formdata, groupId: groupId })
  }, [groupId])

  const save = async () => {

    try {
      const res = await Axios.post(
        `${urldashboard}/Group/CreatePriceList`, JSON.stringify(formdata),
        {
          headers: {
            Authorization: authentication,
            "Content-Type": "application/json; charset=utf-8 ",
          },
        }
      );

      const data = await res.data;
      //handelLoadingform(false)
      toast.success(data.message, {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      refreshPriceTable();
      handleCloseMoudal();

      // datafeching(startpage, pageSize, serch);
      // setCancelWithPenalty(false);
      // setShowConfirmCancelModal(false);

      // setTimeout(() => {
      //   datafeching(startpage, pageSize, serch);
      // }, 60500);

    } catch (error) {
      //handelerrors(error);
    }

  }

  return (
    <Modal style={{ height: 1000 }} show={showitem} onHide={handleCloseMoudal} size={"xl"}>
      <Modal.Header>
        <Modal.Title>افزودن تعرفه جدید</Modal.Title>
        <i
          className="fa fa-times mr-auto"
          style={{ fontSize: "16px", cursor: "pointer" }}
          onClick={handleCloseMoudal}
          aria-hidden="true"
        ></i>
      </Modal.Header>

      <Modal.Body>

        <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>

          <Col lg='3' md='6' sm='6' xs='6'>
            <InputControl label="روش ثبت سفارش" url='/common/orderRegistrationtypedropdown' name='orderRegistrationType' handelValue={handelValue} defaultValue={formdata.orderRegistrationType} />
          </Col>

          <Col lg='3' md='6' sm='6' xs='6'>
            <InputControl label="نوع شیفت" url='/common/dailytypedropdown' name='dailyType' handelValue={handelValue} defaultValue={formdata.dailyType} />
          </Col>

          <Col lg='3' md='6' sm='6' xs='6'>
            <InputDate label="از تاریخ" name='fromDate' handelValue={handelValue}
              defaultValue={formdata.hasOwnProperty('fromDate') ? formdata.fromDate.split("T")[0] : ''} />
          </Col>

          <Col lg='3' md='6' sm='6' xs='6'>
            <InputDate label="تا تاریخ" name='toDate' handelValue={handelValue}
              defaultValue={formdata.hasOwnProperty('toDate') ? formdata.toDate.split("T")[0] : ''} />
          </Col>

          <Col lg='3' md='6' sm='6' xs='6'>
            <InputPricing label="هزینه پایه آقا" name='maleBaseAmount' handelValue={handelValue} defaultValue={formdata.maleBaseAmount} />
          </Col>

          <Col lg='3' md='6' sm='6' xs='6'>
            <InputPricing label="هزینه پایه خانم" name='femaleBaseAmount' handelValue={handelValue} defaultValue={formdata.femaleBaseAmount} />
          </Col>

          <Col lg='3' md='6' sm='6' xs='6'>
            <InputPricing label="پورسانت آقا" name='maleCommission' handelValue={handelValue} defaultValue={formdata.maleCommission} />
          </Col>

          <Col lg='3' md='6' sm='6' xs='6'>
            <InputPricing label="پورسانت خانم" name='femaleCommission' handelValue={handelValue} defaultValue={formdata.femaleCommission} />
          </Col>

          <Col lg='3' md='6' sm='6' xs='6'>
            <InputPricing label="هزینه ساعتی آقا" name='maleCostPerHour' handelValue={handelValue} defaultValue={formdata.maleCostPerHour} />
          </Col>

          <Col lg='3' md='6' sm='6' xs='6'>
            <InputPricing label="هزینه ساعتی خانم" name='femaleCostPerHour' handelValue={handelValue} defaultValue={formdata.femaleCostPerHour} />
          </Col>

          <Col lg='3' md='6' sm='6' xs='6'>
            <InputPricing label="حداقل ساعت آقا" name='maleMinimumTime' handelValue={handelValue} defaultValue={formdata.maleMinimumTime} />
          </Col>

          <Col lg='3' md='6' sm='6' xs='6'>
            <InputPricing label="حداقل ساعت خانم" name='femaleMinimumTime' handelValue={handelValue} defaultValue={formdata.femaleMinimumTime} />
          </Col>

          <Col lg='3' md='6' sm='6' xs='6'>
            <InputNumber label="مقدار ساعت از" name='fromHour' handelValue={handelValue} defaultValue={formdata.fromHour} />
          </Col>

          <Col lg='3' md='6' sm='6' xs='6'>
            <InputNumber label="مقدار ساعت تا" name='toHour' handelValue={handelValue} defaultValue={formdata.toHour} />
          </Col>

        </div>

      </Modal.Body>

      <Modal.Footer>

        <Button
          disabled={saveLoading}
          onClick={() => save(!saveLoading)}
          variant="success"
        >
          {saveLoading ? (
            <i className="fa fa-spinner fa-pulse fa-fw"></i>
          ) : (
            "ذخیره"
          )}
        </Button>

      </Modal.Footer>

    </Modal>
  )

};

export default ModalPriceForm;
